
import { trackEvent } from "bwax/query/simpleActions"

import qs from 'query-string';

export default function track (event, params = {}) {
    if(typeof(gtag) !== "undefined") {
        gtag("event", event, params);
    }

    // bing advertisement:
    if(event === "translate_start" || event == "translate_finish") {
        if(typeof(uetq) !== "undefined") {
            uetq.push('event', event, params);
        }
    }

    // tx advertisement:
    if(typeof(gdt) !== "undefined") {
        if(event === "translate_start") {
            gdt('track', 'COMPLETE_ORDER', params);
        } else if(event === "translate_finish") {
            gdt('track', 'PURCHASE', params);
        }
    }
}

// react hooks
export function useTrack() {

    function __track__(event, params) {
        
        track(event, params);

        function getReferrer() {
            if (typeof (document) !== "undefined") {
                return document.referrer
            } else {
                return ""
            }
        }
    
        function getRK() {
            if (typeof (window) !== 'undefined') {
                const search = window.location.search;
                return qs.parse(search)._rk_
            } else {
                return undefined
            }
        }
    
        function getRKHeaders() {
            if (typeof (window) !== 'undefined') {
                const rk = getRK() || sessionStorage.getItem("_rk_");
                if (rk) {
                    return {
                        "X-RK": rk
                    }
                }
            }
            return {}
        }

        function getPath () {
            if (typeof (window) !== 'undefined') {
                const reg = /^(\/sandbox(\/-\/[^\/]+)?)\/.+/;

                const pathname = window.location.pathname;
                const m = pathname.match(reg);

                if(m) {
                    const prefix = m[1];
                    return pathname.substring(prefix.length);
                } else {
                    return pathname;
                }

            }
            return ""
        };

        try {
            // NO LOCAL TRACK ANY LONGER

            const path = getPath();
            trackEvent({
                path, event, params, referrer: getReferrer(), rkHeaders: getRKHeaders()
            })
            

        } catch (error) {
            console.error(error);
        }
    

    }

    return __track__

}


